import i18n from 'i18next';

export default () => [
  {
    icon: 'audienceCustomer',
    label: i18n.t('customer'),
    description: i18n.t('customer-description'),
    value: 'Customer',
  },
  {
    icon: 'audienceEmployee',
    label: i18n.t('employee'),
    description: i18n.t('employee-description'),
    value: 'Employee',
  },
  {
    icon: 'audiencePartner',
    label: i18n.t('partner'),
    description: i18n.t('partner-description'),
    value: 'Partner',
  },
];
